// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"9eacbdd0","213":"936f58a7","239":"206f44f5","453":"f0003a49","455":"e85766e6","864":"28256753"}[chunkId] + ".chunk.js";
};